import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import Toast, { Toast as ToastType } from './Toast';

interface ToastContainerProps {
  toasts: ToastType[];
  onDismiss: (id: string) => void;
}

const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onDismiss }) => {
  return (
    <div className="fixed bottom-4 right-4 z-[60] w-96 max-w-[calc(100vw-2rem)] pointer-events-none flex flex-col gap-2">
      {toasts.length > 1 && (
        <button
          onClick={() => toasts.forEach(toast => onDismiss(toast.id))}
          className="pointer-events-auto self-end mb-2 px-3 py-1 bg-white/90 hover:bg-white text-gray-600 rounded-full text-sm shadow-lg flex items-center gap-1 transition-colors"
        >
          <X className="w-3 h-3" />
          Verwijder alle ({toasts.length})
        </button>
      )}
      <AnimatePresence mode="sync">
        {toasts.map((toast) => (
          <div key={toast.id} className="pointer-events-auto">
            <Toast toast={toast} onDismiss={onDismiss} />
          </div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default ToastContainer;